var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"self"},[_c('div',{staticClass:"container"},[_c('com-h1',{attrs:{"title":"联席主席"}}),_c('com-speakers',{attrs:{"speakers":_vm.speakers}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }